// extracted by mini-css-extract-plugin
export default {"button":"Ml-z","reviewSort":"Nl-z"};